import React from "react";
import ReactSpeedometer from "react-d3-speedometer";

export interface GaugeProps {
  value: number; // 0–100 (IVV)
  vendidos?: number;
  restantes?: number;
  size?: number;
}

const TicksOverlay: React.FC<{ size: number; ringWidth: number }> = ({
  size,
  ringWidth,
}) => {
  const w = size;
  const h = size * 0.5;
  const cx = w / 2;
  const cy = h;

  // raio externo do semicírculo
  const radius = Math.min(w / 2 - ringWidth / 2, h) - 14;

  const ticks = Array.from({ length: 11 }, (_, i) => i * 10); // 0,10..100

  return (
    <svg
      width={w}
      height={h}
      style={{ position: "absolute", top: 0, left: 0, pointerEvents: "none" }}
    >
      {ticks.map((val, i) => {
        const t = i / 10;
        const angle = Math.PI * (1 - t);
        const r1 = radius + ringWidth / 2 - 4; // início do tick
        const r2 = r1 - 2; // fim do tick
        const rl = r1 + 10; // labels fora do arco

        const x1 = cx + r1 * Math.cos(angle);
        const y1 = cy - r1 * Math.sin(angle);
        const x2 = cx + r2 * Math.cos(angle);
        const y2 = cy - r2 * Math.sin(angle);
        const lx = cx + rl * Math.cos(angle);
        const ly = cy - rl * Math.sin(angle);

        // não desenha os labels de 0 e 100 aqui (vamos renderizar eles fora, absolutos)
        if (val === 0 || val === 100) {
          return (
            <g key={val}>
              <line
                x1={x1}
                y1={y1}
                x2={x2}
                y2={y2}
                stroke="#757cc0ff"
                strokeWidth={1}
              />
            </g>
          );
        }

        return (
          <g key={val}>
            <line
              x1={x1}
              y1={y1}
              x2={x2}
              y2={y2}
              stroke="#757cc0ff"
              strokeWidth={1}
            />
            <text
              x={lx}
              y={ly}
              textAnchor="middle"
              alignmentBaseline="middle"
              fontSize="10"
              fontWeight="500"
              fill="#29306A"
            >
              {val}
            </text>
          </g>
        );
      })}
    </svg>
  );
};

const VelocidadeVendasGauge: React.FC<GaugeProps> = ({
  value,
  size = 200,
}) => {
  const ringWidth = 30;

  return (
    <div
      style={{
        width: size,
        height: size * 0.7,
        margin: "0 auto",
        position: "relative",
      }}
    >
      <ReactSpeedometer
        maxValue={100}
        value={value}
        width={size}
        height={size * 0.7}
        needleColor="#29306A"
        needleHeightRatio={0.7}
        ringWidth={ringWidth}
        forceRender={true}
        currentValueText={`${Math.round(value)}%`}
        textColor="#29306A"
        valueFormat="d"
        segments={1}
        segmentColors={["url(#gaugeGradient)"]}
        customSegmentLabels={[{ text: "" }]} // desliga labels nativos
      />

      {/* ticks + labels externos */}
      <TicksOverlay size={size} ringWidth={ringWidth} />

      {/* labels absolutos para 0 e 100 */}
      <div
        style={{
          position: "absolute",
          bottom: 30,
          left: 5,
          fontSize: "10px",
          fontWeight: "500",
          color: "#29306A",
        }}
      >
        0
      </div>
      <div
        style={{
          position: "absolute",
          bottom: 30,
          right: 0,
          fontSize: "10px",
          fontWeight: "500",
          color: "#29306A",
        }}
      >
        100
      </div>

      {/* 🔹 Gradiente injetado no SVG */}
      <svg style={{ height: 0 }}>
        <defs>
          <linearGradient id="gaugeGradient" x1="40%" y1="50%" x2="100%" y2="60%">
            <stop offset="0%" stopColor="#ff0000ff" />
            <stop offset="40%" stopColor="#fcf800ff" />
            <stop offset="100%" stopColor="#0ad425ff" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default VelocidadeVendasGauge;
